import {
  object,
  func
} from 'prop-types'

export default {
  state: object.isRequired,
  setState: func.isRequired,
}